// 状态文案与颜色：按文档 18 §4 的收敛规则（12 种状态 → 5 色 + 灰），不沿用老系统 antd 的 12 色。
import type { OrderStatus, StockStatusValue } from '@/api/types';

export type TagTone = 'none' | 'amber' | 'blue' | 'violet' | 'orange' | 'green' | 'red';

export const orderStatus: Record<OrderStatus, { label: string; tone: TagTone }> = {
  DRAFT: { label: '草稿', tone: 'none' },
  SUBMITTED: { label: '待审核', tone: 'amber' },
  APPROVED: { label: '已审核', tone: 'blue' },
  IN_PREPARATION: { label: '备货中', tone: 'blue' },
  STOCK_READY: { label: '配货齐全', tone: 'green' },
  ASSEMBLING: { label: '组装中', tone: 'violet' },
  ASSEMBLED: { label: '待发货', tone: 'violet' },
  PARTIALLY_SHIPPED: { label: '部分发货', tone: 'orange' },
  COMPLETED: { label: '已完成', tone: 'green' },
  CLOSED: { label: '已结案', tone: 'none' },
  CANCELLED: { label: '已取消', tone: 'none' },
  REFUND_REQUESTED: { label: '申请退款', tone: 'red' },
};

/** 流程步骤条上的 8 步（文档 18 / 订单 E1） */
export const orderFlow: { status: OrderStatus[]; label: string }[] = [
  { status: ['DRAFT'], label: '草稿' },
  { status: ['SUBMITTED'], label: '待审核' },
  { status: ['APPROVED', 'IN_PREPARATION'], label: '备货中' },
  { status: ['STOCK_READY'], label: '配货齐全' },
  { status: ['ASSEMBLING'], label: '组装中' },
  { status: ['ASSEMBLED'], label: '待发货' },
  { status: ['PARTIALLY_SHIPPED'], label: '部分发货' },
  { status: ['COMPLETED', 'CLOSED'], label: '已完成' },
];

export const stockStatus: Record<StockStatusValue, { label: string; dot: 'green' | 'amber' | 'red' | 'grey' }> = {
  READY: { label: '配货齐全', dot: 'green' },
  PARTIAL: { label: '部分可发', dot: 'amber' },
  SHORTAGE: { label: '缺货', dot: 'red' },
  COMPLETED: { label: '无待发', dot: 'grey' },
};

export const exceptionType: Record<string, { label: string; tone: TagTone }> = {
  DAMAGED: { label: '破损', tone: 'red' },
  SHORT_SHIPPED: { label: '少发', tone: 'amber' },
  RESHIPMENT: { label: '补发', tone: 'blue' },
  RETURNED: { label: '退货', tone: 'orange' },
};

export const exceptionStatus: Record<string, { label: string; tone: TagTone }> = {
  PENDING: { label: '待处理', tone: 'amber' },
  PROCESSING: { label: '处理中', tone: 'blue' },
  RESOLVED: { label: '已处理', tone: 'green' },
  CLOSED: { label: '已关闭', tone: 'none' },
};

/** 修改记录三态（文档 18 §4.2）：待审核 amber / 待跟单知晓 red / 已知晓 green */
export function changeState(cr?: { status: string; followerAcknowledgedAt?: string | null } | null) {
  if (!cr) return null;
  if (cr.status === 'PENDING' || cr.status === 'APPLYING') return { label: '变更待审核', tone: 'amber' as TagTone };
  if (cr.status === 'APPROVED' && !cr.followerAcknowledgedAt) return { label: '待跟单知晓', tone: 'red' as TagTone };
  if (cr.status === 'APPROVED') return { label: '已知晓', tone: 'green' as TagTone };
  return null;
}

export const invoiceStatus: Record<string, string> = {
  NOT_REQUIRED: '无需开票',
  TO_CONFIRM: '待开票',
  PENDING: '待开票',
  ISSUED: '已开票',
};
